// extracted by mini-css-extract-plugin
module.exports = {"heading":"QueryError-heading-f7adc21d1564874a50bc5d941a8dca4f","section":"QueryError-section-9b13375153f39bdeb8e50ea9cd5230f7"};